// extracted by mini-css-extract-plugin
export const artist__nav = "ArtistMenu-module--artist__nav--3qhGu";
export const artist__nav_option = "ArtistMenu-module--artist__nav_option--DEWAf";
export const artist__nav_option_disabled = "ArtistMenu-module--artist__nav_option_disabled--1NsMw";
export const selected = "ArtistMenu-module--selected--3Eu0b";